import Controller from '@ember/controller';
import { service } from '@ember/service';

export default class SickbayController extends Controller {
  @service
  features;
}
